import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAznva2YDD8nHjnLMsb_yiMI7YvncNJQeA",
    authDomain: "bookyoursalon-india.firebaseapp.com",
    projectId: "bookyoursalon-india",
    storageBucket: "bookyoursalon-india.firebasestorage.app",
    messagingSenderId: "80626565670",
    appId: "1:80626565670:web:b21e5c19ebb1e1ebd39ce7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


const auth = getAuth();
export { auth };